import { promoteRole } from '@infuse/api/iam/role';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';
import { useGenericPromoteRole } from './generic/useGenericPromoteRole';
import { promoteOrganisationRole } from '@infuse/api/iam/organisation';
import { promoteTenantRole } from '@infuse/api/iam/tenant';

export const usePromoteRole = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.ORGANISATION) {
    return useGenericPromoteRole({
      apiFn: promoteOrganisationRole,
      forcedParentId: user?.organisationId
    });
  } else if (level === UserLevel.TENANT) {
    return useGenericPromoteRole({
      apiFn: promoteTenantRole,
      forcedParentId: user?.tenantId
    });
  }

  return useGenericPromoteRole({
    apiFn: promoteRole
  });
};
